import { render, staticRenderFns } from "./FAQGestionnaire.vue?vue&type=template&id=3b5bb49c&scoped=true&"
var script = {}
import style0 from "./FAQ.scss?vue&type=style&index=0&id=3b5bb49c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bb49c",
  null
  
)

export default component.exports